var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExitScreenElementLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 222,
    height: 533,
    viewBox: "0 0 222 533",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0368244 242.604C-67.1459 262.025 -115.55 318.965 -114.494 385.903C-113.214 467.123 -38.0854 532.82 52.4587 531.992C142.958 531.178 216.048 465.121 216.048 383.741C216.048 347.716 203.192 313.533 177.896 289C110.312 223.424 -107.351 39.7212 -107.351 39.7212C-123.511 25.5995 -112.366 0.999968 -89.7931 0.999967L222 0.999954",
    stroke: "url(#paint0_linear_407_9)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_407_9",
    x1: 67.0196,
    y1: 0.999944,
    x2: 70.988,
    y2: 532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34C6F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BA6E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitScreenElementLeft);
export default __webpack_public_path__ + "static/media/exitScreenElementLeft.56089de427d2a110e55f5046023da4fa.svg";
export { ForwardRef as ReactComponent };